import { Injectable } from "@angular/core";
import {  Headers } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { AdalHttp } from '../../services/adal.http.service';
import "rxjs/add/operator/map";
import "rxjs/add/operator/do";
import "rxjs/add/operator/catch";
import { UserManagementRequest } from "./user-management-request";

@Injectable()
export class UserManagementService {
    constructor(private http: AdalHttp) {
    }

    addUser(userManagementRequest: UserManagementRequest): Observable<any> {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let productUrl: string = "/api/user/add";
        return this.http.post(productUrl, userManagementRequest, {
                headers: headers
            })
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    getDetailsOfUser(userId: string) {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let productUrl: string = `/api/user/${userId}/details`;
        return this.http.get(productUrl)
            .catch((error: any) => {
                return Observable.throw(error);
            });

    }
    fetchUserDetailsByUserName(userName: string) {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let productUrl: string = `/api/users/username/${userName}`;
        return this.http.get(productUrl)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }
    deleteUser(userId: string) {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let productUrl: string = `/api/user/${userId}/delete`;
        return this.http.delete(productUrl)
            .catch((error: any) => {
                return Observable.throw(error);
            });

    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/userManagement/user-management.service.ts
 **/